import React from 'react';
import 'antd/dist/antd.css';
import { DraggableArea } from 'react-draggable-tags';
import SVGIcons from '../SVGIcons';
import { Select, Switch, Tooltip } from 'antd';
import { Popover, Button, Menu } from 'antd';
import { HEATMAP_OPTIONS, HEATMAP_MESSAGE, HEATMAP_MESSAGE_OPTIONS } from './constants';
import { SelectElement } from '../../FormElements/SelectElement';
const { Option } = Select;

// import ScrollBar from "../../Packages/ScrollBar";
export class HeatmapHeaders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showHeaderMenu: false
        }
    }

    selectHeatmapHeader = (selectedHeader) => {
        const selectedHeaders = [...this.props.selectedHeaders, selectedHeader.content]
        this.props.onSelectHeader(selectedHeaders)
        this.setState({
            showHeaderMenu: false,
        });
        this.props.resetTopicQuestions()
    };

    removeHeatmapHeader = (selectedHeader) => {
        const selectedHeaders = [...this.props.selectedHeaders]
        selectedHeaders.splice(selectedHeaders.indexOf(selectedHeader), 1)
        this.props.onSelectHeader(selectedHeaders)
        this.setState({
            showHeaderMenu: false,
        });
        this.props.resetTopicQuestions()
    };

    onChangeTagOrder = (tags) => {
        const selectedHeaders = tags.map(item => item.content)
        this.props.onSelectHeader(selectedHeaders)
        this.setState({
            showHeaderMenu: false,
        });
        this.props.resetTopicQuestions()
    }

    handleVisibleChange = showHeaderMenu => {
        this.setState({ showHeaderMenu });
    };



    renderTagContent = (tagContent) => {
        if (tagContent && tagContent.length > 10) {
            return (<Tooltip title={tagContent}>
                <span>{tagContent.substring(0, 10) + '...'}</span>
            </Tooltip>)
        }
        return <span>{tagContent}</span>
    }

    getSelectedHeaders = () => {
        let selectedHeaders = this.props.headers.filter(item =>
            this.props.selectedHeaders.includes(item.content)
        )
        selectedHeaders.sort((a, b) => this.props.selectedHeaders.indexOf(a.content) -
            this.props.selectedHeaders.indexOf(b.content))
        return selectedHeaders;
    }

    getPopoverMenu = () => {
        return this.props.headers.map(item =>

            <Menu.Item
                disabled={this.props.selectedHeaders.includes(item.content)}
                onClick={() => this.selectHeatmapHeader(item)}>{item.content}

            </Menu.Item>
        )
    }


    getHeadersDropdown = () => {
        return <Popover
            content={<Menu>{this.getPopoverMenu()}</Menu>}
            title=""
            overlayClassName="heatmap-popover"
            trigger="click"
            visible={this.state.showHeaderMenu}
            onVisibleChange={this.handleVisibleChange}
        >
            <Button className='add-headers'><SVGIcons type={'SVG-plus'} /></Button>
        </Popover>
    }

    getGapScoresToggleButton = () => {
        return (
            <div className="toggle-block">
                <p>Gap Scores</p>
                <Switch checked={!this.props.showScores} onChange={this.props.onToggleShowScores} />
            </div>
        )
    }

    getColorsToggleButton = () => {
        return (
            <div className="toggle-block">
                <p>Colors</p>
                <Switch checked={!this.props.hideColors} onChange={this.props.onToggleHideColors} />
            </div>
        )
    }


    getScoreLevelMenu = () => {
        return (
            <div className="score-block">
                <p>Score Type:{" "}</p>
                <Select
                    bordered={false}
                    suffixIcon={<SVGIcons type={"SVG-dropdown"} />}
                    value={this.props.selectedScoreLevel}
                    onChange={(event) => {
                        this.props.onChangeScoreType(event)
                    }}
                >
                    {this.props.scoreLevelList.map((value) => (
                        <Option key={value.value}>{value.label}</Option>
                    ))}
                </Select>
            </div>
        //   <DotMenu
        //     selectedKeys={this.props.selectedScoreLevel}
        //     itemList={this.props.scoreLevelList}
        //   />
        );
    }

    getComparisonSelectionMenu = () => {
        if (this.props.isTrendHeatmap) {
            return (

                <div className="trendcomparison-block">
                    <p>Comparison:{" "}</p>
                    <SelectElement
                        maxTagCount={2}
                        isCustomDisable={true}
                        disableBasedOnSelectedCount={2}
                        disableSearch={true}
                        mode="multiple"
                        value={this.props.selectedLevel}
                        showArrow={false}
                        onChange={(value) => { this.props.onChangeComparisonLevel(value) }}
                        placeholder="Select Comparison"
                        optionList={this.props.comparisonLevelList}
                    />
                </div>
            )
        }
        else {
            return (
                <div className="comparison-block">
                    <p>Comparison:{" "}</p>
                    <Select
                        bordered={false}
                        suffixIcon={<SVGIcons type={"SVG-dropdown"} />}
                        value={this.props.selectedLevel}
                        onChange={(event) => {
                            this.props.onChangeComparisonLevel(event)
                        }}
                    >
                        {this.props.comparisonLevelList.map((value) => (
                            <Option key={value.value}>{value.label}</Option>
                        ))}
                    </Select>
                </div>
            )
        }



    }

    getComparisonSelectionMenuForTrend = () => {
        return (
            <div className="comparison-block">
                <p>Comparison:{" "}</p>
                {this.props.isTrendHeatmap ? <SelectElement
                    disableSearch={true}
                    mode="multiple"
                    value={this.props.selectedLevel}
                    showArrow={false}
                    onChange={(value) => { this.props.onChangeComparisonLevel(value) }}
                    placeholder="Select Comparison"
                    optionList={this.props.comparisonLevelList}
                /> :
                    <Select
                        bordered={false}
                        suffixIcon={<SVGIcons type={"SVG-dropdown"} />}
                        value={this.props.selectedLevel}
                        onChange={(event) => {
                            this.props.onChangeComparisonLevel(event)
                        }}
                    >
                        {this.props.comparisonLevelList.map((value) => (
                            <Option key={value.value}>{value.label}</Option>
                        ))}
                    </Select>

                }

            </div>
        )


    }

    getMessage = () => {
        if (this.props.selectedScoreLevel === HEATMAP_OPTIONS.favourable) {
            return HEATMAP_MESSAGE(HEATMAP_MESSAGE_OPTIONS.favourable)
        }
        if (this.props.selectedScoreLevel === HEATMAP_OPTIONS.neutral) {
            return HEATMAP_MESSAGE(HEATMAP_MESSAGE_OPTIONS.neutral)
        }
        if (this.props.selectedScoreLevel === HEATMAP_OPTIONS.unFavourable) {
            return HEATMAP_MESSAGE(HEATMAP_MESSAGE_OPTIONS.unFavourable)
        }
    }
    render() {
        return (
            <>
                <div  className="heatmap-head">
                <div className="heatmap-head__left">
                     <h2>{this.props.heatmapType}</h2>
                     </div>
                
                    <div className="heatmap-head__right">
                        {this.props.comparisonLevelList && this.props.comparisonLevelList.length > 0 && this.getComparisonSelectionMenu()}
                        {this.getScoreLevelMenu()}
                        <div className='toggle-area'>
                            {this.getGapScoresToggleButton()}
                            {this.getColorsToggleButton()}
                        </div>
                            {/* {<SVGIcons type={'SVG-settings'} />} */}
                        </div>
                 
                </div>
                <div className="heatmap-headers" >
                    <div className="heatmap-headers__left">
                        <h4 >Table Headers</h4>
                        <DraggableArea
                            tags={this.getSelectedHeaders()}
                            render={({ tag, index }) => (
                                <div className="tag">
                                    <span><SVGIcons type={'SVG-three-dot-menu'} /></span>
                                    {this.renderTagContent(tag.content)}
                                    {<>&nbsp;</> /*remove this when adding styles*/}
                                    <span className="heatmap-pointer-cursor"
                                        onClick={() => this.removeHeatmapHeader(tag.content)}>
                                        <SVGIcons type={'SVG-cross'} />
                                    </span>
                                </div>
                            )}
                            onChange={tags => this.onChangeTagOrder(tags)}
                        />
                        {this.getHeadersDropdown()}

                    </div>
                    {/* <div className='heatmap-headers__center'>
                    {this.getMessage()}
                    </div> */}
                    {/* <div className="heatmap-headers__right">
                    <div className="heatmap-headers__right--toggle">
                        {this.getGapScoresToggleButton()}
                        {this.getColorsToggleButton()}
                        </div>
                        <div className="heatmap-headers__right--menu">
                        {this.getScoreLevelMenu()}
                        {<SVGIcons type={'SVG-settings'} /> }
                        </div>
                    </div> */}
                </div>

            </>
        );
    }
}
